module.exports = __webpack_public_path__ + "img/gallery15.a10214ce.jpg";